import { render, staticRenderFns } from "./checkBox.vue?vue&type=template&id=e505600e&scoped=true"
import script from "./checkBox.vue?vue&type=script&lang=ts"
export * from "./checkBox.vue?vue&type=script&lang=ts"
import style0 from "./checkBox.vue?vue&type=style&index=0&id=e505600e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e505600e",
  null
  
)

export default component.exports